/**
 * Column Color Presets
 *
 * Theme-derived color presets for board column customization.
 * Used by CreateBoardForm and EditControlsOverlay.
 */

import type { ColorPalette } from '@/styles/colors/types';

interface PresetColor {
  value: string;
  label: string;
}

/**
 * Returns the full set of preset colors for the column color picker,
 * derived from the current theme palette.
 */
export function getPresetColumnColors(colors: ColorPalette): PresetColor[] {
  return [
    { value: colors.medium, label: 'Slate' },
    { value: colors.blue, label: 'Blue' },
    { value: colors.success, label: 'Green' },
    { value: colors.rust, label: 'Amber' },
    { value: colors.error, label: 'Red' },
    { value: colors.purple, label: 'Purple' },
    { value: colors.coral, label: 'Pink' },
    { value: colors.teal, label: 'Cyan' },
    { value: colors.forest, label: 'Teal' },
    { value: colors.primary, label: 'Orange' },
    { value: colors.lightPurple, label: 'Indigo' },
    { value: colors.dark, label: 'Gray' },
  ];
}

/**
 * Returns default column colors for new board creation.
 */
export function getDefaultColumnColors(colors: ColorPalette) {
  return {
    TODO: colors.medium,
    IN_PROGRESS: colors.blue,
    DONE: colors.success,
  } as const;
}
